export default "__VITE_ASSET__BfArR1tW__"